/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookOnlineConfigurationData } from '../../models/book-online-configuration-data';

export interface GetBookOnlineConfigData$Params {

/**
 * id of configuration type book
 */
  bookId: string;
}

export function getBookOnlineConfigData(http: HttpClient, rootUrl: string, params: GetBookOnlineConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<BookOnlineConfigurationData>> {
  const rb = new RequestBuilder(rootUrl, getBookOnlineConfigData.PATH, 'get');
  if (params) {
    rb.path('bookId', params.bookId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BookOnlineConfigurationData>;
    })
  );
}

getBookOnlineConfigData.PATH = '/api/configuration/book/{bookId}/online';
